import { useTranslate } from "@tolgee/react";
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
} from "#/components/ui/alert-dialog";

interface WithdrawConfirmAlertProps {
	open: boolean;
	onOpenChange: (next: boolean) => void;
	amount: string;
	address: string;
	onConfirm: () => void;
}

export function WithdrawConfirmAlert({
	open,
	onOpenChange,
	amount,
	address,
	onConfirm,
}: WithdrawConfirmAlertProps) {
	const { t } = useTranslate();

	return (
		<AlertDialog open={open} onOpenChange={onOpenChange}>
			<AlertDialogContent size="sm">
				<AlertDialogHeader>
					<AlertDialogTitle>
						{t("withdraw-confirm.title")}
					</AlertDialogTitle>
					<AlertDialogDescription>
						{t("withdraw-confirm.description", { amount, address })}
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogCancel>
						{t("actions.cancel")}
					</AlertDialogCancel>
					{/* Just "Confirm" — the title already names the action, and the
					    two-column size="sm" footer is too narrow for a verb + noun
					    without the nowrap label spilling out of the button. */}
					<AlertDialogAction onClick={onConfirm}>
						{t("actions.confirm")}
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
}
